var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.124 8.04706H72.9412C76.851 8.08588 80.0002 11.2665 80 15.1765V54.1961C80.0002 58.1061 76.851 61.2869 72.9412 61.3255H7.05883C3.14902 61.2869 -0.000191243 58.1061 4.83581e-06 54.1961V7.13726C-0.00450497 3.22412 3.14589 0.0388235 7.05883 0H30.0861C32.0684 0 33.9577 0.840475 35.2851 2.31277L38.6677 6.06468C39.8054 7.32665 41.4249 8.04706 43.124 8.04706Z",
    fill: "#E2E5E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDocument);
export default __webpack_public_path__ + "static/media/folder-document.bccd05422086672b785eda7fd2be0681.svg";
export { ForwardRef as ReactComponent };